import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'
import { RouteKeys, routesFi } from './i18n/extranet-routes'
import { localizeLinkPath } from './router-utils'

export const useExtranetPath = () => {
  const { language } = useTranslation().i18n

  return (routeLabel: RouteKeys, params?: Record<string, unknown>) => {
    const routePath = routesFi[routeLabel] || false

    if (!routePath) {
      return language === 'fi' ? '/' : '/' + language
    }

    const localizedPath = localizeLinkPath(language, routeLabel)

    if (typeof localizedPath !== 'string') {
      return language === 'fi' ? '/' : '/' + language
    }

    const generatedPath = generatePath(localizedPath, params)

    return generatedPath
  }
}
